<template>
	<div class="activity-poll-response-body">
		<ProfilePic v-if="user" :user="user" size="36px" class="poll-avatar" />
		<div class="poll-content">
			<div v-if="user" class="poll-author" v-text="user.fullname" />
			<div v-if="item.poll" class="poll-card">
				<div class="poll-question" v-text="item.poll.question" />
				<ul class="poll-options">
					<li
						v-for="opt in item.poll.options"
						:key="opt.id"
						class="poll-option"
						:class="{ selected: opt.id === item.poll_option?.id }"
					>
						<CircleCheckIcon
							v-if="opt.id === item.poll_option?.id"
							type="solid"
							class="option-icon selected"
						/>
						<CircleIcon v-else type="regular" class="option-icon" />
						<span class="option-text" v-text="opt.text" />
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { CircleIcon, CircleCheckIcon } from '@/icons'
import { ProfilePic } from '@/components/common'

export default {
	name: 'ActivityPollResponseBody',

	components: { CircleIcon, CircleCheckIcon, ProfilePic },

	props: {
		item: { type: Object, required: true },
		user: { type: Object, default: null },
	},
}
</script>

<style lang="scss" scoped>
.activity-poll-response-body {
	display: flex;
	gap: 19px;
	align-items: flex-start;
}

.poll-avatar {
	flex-shrink: 0;
}

.poll-content {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.poll-author {
	font-family: Avenir-Heavy;
	font-size: 15px;
	color: var(--neutral-800);
}

.poll-card {
	background: var(--neutral-100);
	border-radius: 12px;
	padding: 12px 12px 24px;
	display: flex;
	flex-direction: column;
	gap: 22px;
	width: 274px;
	max-width: 100%;
}

.poll-question {
	font-family: Avenir-Heavy;
	font-size: 16px;
	color: var(--neutral-800);
}

.poll-options {
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.poll-option {
	display: flex;
	align-items: center;
	gap: 8px;
	font-family: Avenir-Roman;
	font-size: 16px;
	color: var(--neutral-800);

	.option-icon {
		font-size: 24px;
		color: var(--neutral-400);

		&.selected {
			color: var(--teal-300);
		}
	}
}
</style>
